import React, { useContext, useState } from 'react'
import { Card, enhancedFetch, Form, PasswordInput, SubmitButton, TextInput } from 'journey-ui'
import { useRouter } from 'next/router'
import { AppPage } from '../components/Layout/AppPage'
import { AppContext } from '../contexts/AppContext'

const SignUpPage: React.FC = () => {
  const [form, setForm] = useState({
    restaurant_name: '',
    name: '',
    phone_number: '',
    email: '',
    password: '',
    time_zone_name: Intl.DateTimeFormat().resolvedOptions().timeZone,
  })

  const { setBrand, setUser } = useContext(AppContext)

  const router = useRouter()

  const onSubmitSignupClick = async () => {
    const { user, brand } = await enhancedFetch<{ user:User, brand: Brand }>('/api/auth/sign-up', {
      method: 'POST',
      body: form,
    })

    setBrand(brand)
    setUser(user)

    await router.push(`/brand/${brand.hash_id}/optimizations`)
  }

  return (
    <AppPage title="Sign Up">
      <Card className="m-2">
        <Form value={form} onChange={setForm}>
          <TextInput name="name" label="Full Name" />
          <TextInput type="phone" name="phone_number" />
          <TextInput type="email" name="email" />
          <PasswordInput name="password" />
          <TextInput name="restaurant_name" />
          <TextInput type="phone" name="restaurant_phone_number" />
          <SubmitButton onClick={onSubmitSignupClick} />
        </Form>
      </Card>
    </AppPage>
  )
}

export default SignUpPage
